<template>
  <div class="top-mobile-wrapper d-md-block d-lg-none">
    <span @click="close_mobile_menu()"><i class="fas fa-times"></i></span>
  </div>
</template>

<script>
export default {
  methods: {
    close_mobile_menu () {
      this.$emit('close-mobile-menu')
    }
  }
}
</script>

<style scoped lang="scss">
.top-mobile-wrapper {
  background-color: var(--white-black);
  padding: 0 20px;
  text-align: right;

  span {
    @include basic-transition;
    line-height: 50px;
    color: var(--cool-grey);
    opacity: .5;
    font-size: 17px;
    cursor: pointer;

    &:hover {
      opacity: .25;
    }
  }
}
</style>
